import React from 'react';

const SocialIcon = ({ href, src, alt, iconClass }) => {
  return (
    <div >
      <a href={href} target="_blank" rel="noreferrer">
        <img src={src} alt={alt} className={`${iconClass}`} />
      </a>
    </div>
  );
};

export default SocialIcon;